<ng-template #toolbarTemplate>
  @for (item of items; track item.text) {
  <span style="margin-right:7px">
    @if (item.isBadge) {
    <kendo-badge-container>
      <button kendoButton (click)="itemSelected(item)" class="{{item.cssClass}}" [title]="item.text | translate">
        @if (item.icon != undefined) { <fa-icon [icon]="item.icon"></fa-icon> }
        {{item.text | translate}}
      </button>
      <kendo-badge>{{ item.badgeValue }}</kendo-badge>
    </kendo-badge-container>
    }
    @if (!item.isBadge && item.hasMultiple) {
    <kendo-splitbutton buttonClass="{{item.cssClass}}" [iconClass]="item.iconClass ?? ''" [text]="item.text | translate" [title]="item.text | translate" [data]="item.items" (itemClick)="subItemSelected($event)">
      <ng-template kendoSplitButtonItemTemplate let-dataItem>
        @if (dataItem.events) {
        <span>
          @for (e of dataItem.events; track e) {
          <button kendoButton class="eventBtn" [ngStyle]="{'background-color': e.bgColor}" title="{{e.title}}">
            @if (e.icon) { <fa-icon [icon]="e.icon"></fa-icon> }
          </button>
          }
        </span>
        }
        @if (dataItem.icon) {
        <button kendoButton class="eventBtn" [ngStyle]="{'background-color': dataItem.bgColor}">
          <fa-icon [icon]="dataItem.icon"></fa-icon>
        </button>
        }
        {{dataItem.text | translate}}
      </ng-template>
    </kendo-splitbutton>
    } @else if (!item.isBadge && !item.hasMultiple) {
    <button kendoButton (click)="itemSelected(item)" class="{{item.cssClass}}" [title]="item.text | translate">
      @if (item.icon != undefined) { <fa-icon [icon]="item.icon"></fa-icon> }
      {{item.text | translate}}
    </button>
    }
  </span>
  }
</ng-template>
